<div mat-dialog-title class="row d-flex">
  <h2>{{ data.title }}</h2>
  <button mat-button class="ml-auto" (click)="onNoClick()" tabindex="-1">
    <mat-icon fontIcon="fa-times"></mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <p [innerHTML]="data.content | htmlSafe"></p>
</div>

<div mat-dialog-actions class="pr-2">
  <button mat-raised-button color="primary" class="ml-auto" [mat-dialog-close]="true">
    {{ data.confirmText ? data.confirmText : 'Yes' }}
  </button>
  <button class="mr-1" mat-raised-button [mat-dialog-close]="false">
    {{ data.confirmText ? data.denyText : 'No' }}
  </button>
  <button mat-raised-button (click)="onNoClick()" *ngIf="data.includeCancel">Cancel</button>
</div>
